import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  programmeActionsQuestionnaireFilledOutIds: [] as string[],
};

export const programmeActionsQuestionnaireFilledOutIdsSlice = createSlice({
  name: "filledOutQuestionnairesSlice",
  initialState,
  reducers: {
    addFilledOut: (state, action) => {
      state.programmeActionsQuestionnaireFilledOutIds =
        state.programmeActionsQuestionnaireFilledOutIds.concat([
          action.payload.filledOutProgrammeId,
        ]);
    },
  },
});

export const { addFilledOut } =
  programmeActionsQuestionnaireFilledOutIdsSlice.actions;

export const programmeActionsQuestionnaireFilledOutIdsReducer =
  programmeActionsQuestionnaireFilledOutIdsSlice.reducer;
